import React from "react";
import PropTypes from "prop-types";
import withStyles from "@mui/styles/withStyles";
import Typography from "@mui/material/Typography";
import FormHelperText from "@mui/material/FormHelperText";
import TextField from "@mui/material/TextField";
//Limitless imports
import { withi18n } from "@limitless/customer/components";

const NewQuestionTextInput = ({ t, classes, label, error, helperText, containerClass, ...rest }) => {
    const { labelText, textInput, placeholder, ...otherClasses } = classes;

    return (
        <div className={containerClass}>
            <Typography variant="body2" component="div" className={labelText}>
                {t(label)}
            </Typography>
            <TextField
                variant="outlined"
                label=""
                inputProps={{ className: textInput, "aria-label": label }}
                InputProps={{ classes: { ...otherClasses } }}
                style={{ marginTop: 1 }}
                {...rest}
            />
            {error ? <FormHelperText error={error}>{t(helperText)}</FormHelperText> : <div className={placeholder} />}
        </div>
    );
};

const styles = theme => ({
    labelText: {
        marginBottom: 4
    },
    textInput: {
        fontSize: "0.875rem",
        "@media screen and (max-width: 450px)": {
            fontSize: 16
        }
    },
    placeholder: {
        height: 20,
        marginTop: 3
    },
    root: {
        "& $notchedOutline": {
            border: "1px solid rgba(0,0,0,0.23)"
        },
        "&:hover $notchedOutline": {
            borderColor: "rgba(0,0,0,0.23)"
        },
        "&$focused $notchedOutline": {
            borderColor: theme.palette.contrast.dark ?? theme.palette.primary.main,
            borderWidth: 2
        }
    },
    //Empty objects are needed to reset the MUI styles
    notchedOutline: {},
    focused: {}
});

export default withStyles(styles)(withi18n(NewQuestionTextInput));

NewQuestionTextInput.propTypes = {
    classes: PropTypes.object.isRequired,
    t: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    error: PropTypes.bool.isRequired,
    helperText: PropTypes.string,
    containerClass: PropTypes.string
};
